/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type EventUnlockConditionsType = (typeof EventUnlockConditionsType)[keyof typeof EventUnlockConditionsType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventUnlockConditionsType = {
  always: 'always',
  all_previous: 'all_previous',
  specific_tasks: 'specific_tasks',
} as const;
